<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">Contents</h1>
<p class="toc-chapter" id="toc-ad-card"><span href="#/adcard" title="Link target outside of Sample">Also by Richard A. Billows</span></p>
<p class="toc-chapter" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-chapter" id="toc-dedication"><span href="#/dedication" title="Link target outside of Sample">Dedication</span></p>
<p class="toc-preface" id="toc-preface001"><a href="#/preface001">Maps</a></p>
<p class="toc-preface" id="toc-preface002"><a href="#/preface002">Family Trees</a></p>
<p class="toc-preface" id="toc-preface003"><a href="#/preface003">Preface</a></p>
<p class="toc-chapter" id="toc-introduction"><a href="#/introduction">Introduction: The Legend of Marathon</a></p>
<p class="toc-chapter1" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">Chapter 1: The Ancient Greeks in the Seventh and Sixth Centuries <span class="small-caps">B. C. E.</span></span></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">Chapter 2: The Rise of the Persian Empire</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Chapter 3: The Athenian City-State About 500 <span class="small-caps">B.C.E.</span></span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Chapter 4: The Growth of Conflict Between Persians and Greeks</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">Chapter 5: The Battle of Marathon</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Chapter 6: The Consequences of the Battle of Marathon</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Chronology of Key Events in Ancient Greece and the Persian Empire</span></p>
<p class="toc-chapter1" id="toc-glossary"><span href="#/glossary" title="Link target outside of Sample">Glossary of Terms</span></p>
<p class="toc-chapter" id="toc-bibliography"><span href="#/bibliography" title="Link target outside of Sample">Further Reading and Bibliography</span></p>
<p class="toc-chapter" id="toc-acknowledgements"><span href="#/acknowledgements" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-chapter" id="toc-index"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?63a34439